import {PersistableState} from './computePersistableState'

// Sérialisation déterministe : clés d'objet triées à tous les niveaux.
// Les tableaux ne sont PAS réordonnés par le replacer (l'ordre de amountModifications est signifiant) ;
// seules les collections de haut niveau sont triées par id avant sérialisation.
const stableStringify = (value: unknown): string =>
  JSON.stringify(value, (_key, val) =>
    (val && typeof val === 'object' && !Array.isArray(val))
      ? Object.keys(val).sort().reduce((acc: Record<string, unknown>, k) => {
          acc[k] = (val as Record<string, unknown>)[k]
          return acc
        }, {})
      : val,
  )

const sortById = <T extends {id: string}>(items: T[]): T[] =>
  [...items].sort((a, b) => a.id.localeCompare(b.id))

const canonical = (state: PersistableState): string =>
  stableStringify({
    oneTimeTransactions: sortById(state.oneTimeTransactions),
    persistedRecurringTransactions: sortById(state.persistedRecurringTransactions),
    recurrences: sortById(state.recurrences),
  })

export const isPersistableStateEqual = (a: PersistableState, b: PersistableState): boolean =>
  canonical(a) === canonical(b)
